import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { rewardEndpointIds } from 'root/src/shared/rewards/constants';
export const getReservedRewardsByDropIdEndpoint = {
    [rewardEndpointIds.GET_RESERVED_REWARDS_BY_DROP]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
            },
            required: ['dropId'],
        },
    },
};
